import { render, staticRenderFns } from "./ShareRinkDialog.vue?vue&type=template&id=a86c3806&scoped=true&"
import script from "./ShareRinkDialog.vue?vue&type=script&lang=js&"
export * from "./ShareRinkDialog.vue?vue&type=script&lang=js&"
import style0 from "./ShareRinkDialog.vue?vue&type=style&index=0&id=a86c3806&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a86c3806",
  null
  
)

export default component.exports